var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandAllIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00141 19.6537L0.347656 13.9999L1.41691 12.9307L6.00141 17.4962L10.5859 12.9307L11.6552 13.9999L6.00141 19.6537ZM1.43216 7.05369L0.347656 5.99994L6.00141 0.346191L11.6552 5.99994L10.5707 7.05369L6.00141 2.50369L1.43216 7.05369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00141 19.6537L0.347656 13.9999L1.41691 12.9307L6.00141 17.4962L10.5859 12.9307L11.6552 13.9999L6.00141 19.6537ZM1.43216 7.05369L0.347656 5.99994L6.00141 0.346191L11.6552 5.99994L10.5707 7.05369L6.00141 2.50369L1.43216 7.05369Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAllIcon);
export default __webpack_public_path__ + "static/media/expandAllIcon.bf787bafa8c3345e66de697e15d8fe2a.svg";
export { ForwardRef as ReactComponent };